import { render, staticRenderFns } from "./CareerAiServiceMenu.vue?vue&type=template&id=0774c1df&scoped=true"
import script from "./CareerAiServiceMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAiServiceMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CareerAiServiceMenu.vue?vue&type=style&index=0&id=0774c1df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774c1df",
  null
  
)

export default component.exports